import { useEffect } from "react";
import { Nav } from "../components/site/Nav";
import { Hero } from "../components/site/Hero";
import { Marquee } from "../components/site/Marquee";
import { HowItWorks } from "../components/site/HowItWorks";
import { Bento } from "../components/site/Bento";
import { OrderSection } from "../components/site/OrderSection";
import { Faq } from "../components/site/Faq";
import { Footer } from "../components/site/Footer";
import { SmoothScroll } from "../components/site/SmoothScroll";

export default function Home() {
  useEffect(() => {
    document.body.style.background = "#FBF7EE";
    return () => { document.body.style.background = ""; };
  }, []);
  return (
    <div className="theme-light grain relative" data-testid="home-page">
      <SmoothScroll />
      <Nav />
      <main>
        <Hero />
        <Marquee />
        <HowItWorks />
        <Bento />
        <OrderSection />
        <Faq />
      </main>
      <Footer />
    </div>
  );
}
